import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import CommissionDownloadModal from "../../components/widgets/modals/DownloadCommission";
import TableComponent from "../../components/widgets/table/index";
import { listEntityCommissions } from "services/apiSrv";
import { useQuery } from "react-query";
import { api_srv } from "services";

function CommissionsAccount() {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const [commissionData, setCommissionData] = useState([]);
  const [totalCommission, setTotalCommission] = useState(0); // State for total commission

  useEffect(() => {
    const fetchCommissions = async () => {
      try {
        const response = await listEntityCommissions();
        console.log("Commissions API response:", response);
        const transformedData = response.data.map(item => ({
          policy: item.quotationSystemRef || 'N/A',
          amount: item.amount || 0,
          date: item.createdAt || 'N/A',
          state: item.commisionSettlement?.commsionSettlementStatus || 'N/A',
          id: item.systemEntityCommisionRef || item.id || 'N/A'
        }));
        setCommissionData(transformedData);

        // Calculate total commission amount
        const total = transformedData.reduce((sum, item) => sum + item.amount, 0);
        setTotalCommission(total);
      } catch (error) {
        console.error("Error fetching commissions:", error);
        setCommissionData([]);
        setTotalCommission(0);
      }
    };
    fetchCommissions();
  }, []);

  const handleViewClick = (id) => {
    if (!id || id === 'N/A') {
      console.error("Invalid commission ref:", id);
      return;
    }
    const targetUrl = `/dashboard/account-management/commissions/${id}`;
    console.log(`Navigating to: ${targetUrl} (Ref: ${id})`);
    history.push(targetUrl);
  };

  const tableFields = [
    { name: "Policy Number" },
    { name: "Commission Amount" },
    { name: "Date Earned" },
    { name: "Payment Status" },
    { name: "Actions" }
  ];

  const rowData = [
    { type: "text", field: "policy" },
    { type: "currency", field: "amount" },
    { type: "date", field: "date" },
    { type: "status", field: "state" },
    {
      type: "action",
      actions: [
        {
          method: handleViewClick,
          field: "id",
          title: "View Details"
        }
      ]
    }
  ];

  const get_commissions = async () => {
    let resp = await (await api_srv).fetchCommisions();
    console.log("commissions==", resp.data);
    return resp.data;
  };

  const { isLoading, isError, isSuccess, data } = useQuery(
    "commissions",
    get_commissions
  );

  return (
    <div className="container my-5">
      {/* Page Header */}
      <div className="mb-5">
        <h3 className="fw-bold text-dark mb-2">My Commissions</h3>
        <p className="text-secondary mb-0">Track and manage your commission earnings</p>
      </div>

      {/* Total Commission */}
      <div className="mb-4">
        <h5 className="fw-bold">Total Commission Earned</h5>
        <h3 className="text-primary">KES {totalCommission.toLocaleString()}</h3>
      </div>

      {/* Summary Cards */}
      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <div className="card shadow-sm h-100 border-0">
            <div className="card-body text-center py-4">
              <div
                className="bg-success bg-opacity-50 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                style={{ width: '60px', height: '60px' }}
              >
                <span
                  className="text-white fw-bold fs-4"
                  style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}
                >
                  T
                </span>
              </div>
              <h6 className="card-title text-secondary mb-2">Today's Earnings</h6>
              <h3 className="text-success fw-bold mb-0">KES 5,000</h3>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm h-100 border-0">
            <div className="card-body text-center py-4">
              <div
                className="bg-primary bg-opacity-50 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                style={{ width: '60px', height: '60px' }}
              >
                <span
                  className="text-white fw-bold fs-4"
                  style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}
                >
                  W
                </span>
              </div>
              <h6 className="card-title text-secondary mb-2">Weekly Earnings</h6>
              <h3 className="text-primary fw-bold mb-0">KES 25,000</h3>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm h-100 border-0">
            <div className="card-body text-center py-4">
              <div
                className="bg-info bg-opacity-50 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                style={{ width: '60px', height: '60px' }}
              >
                <span
                  className="text-white fw-bold fs-4"
                  style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}
                >
                  M
                </span>
              </div>
              <h6 className="card-title text-secondary mb-2">Monthly Earnings</h6>
              <h3 className="text-info fw-bold mb-0">KES 80,000</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Download Section */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 className="mb-1">Commission History</h5>
          <p className="text-secondary mb-0 small">View and manage all your commission records</p>
        </div>
        <button
          className="btn btn-primary d-flex align-items-center px-4 py-2 shadow-sm"
          onClick={() => setShowModal(true)}
          aria-label="Download commission data"
        >
          <FaDownload className="me-2" />
          Export Data
        </button>
      </div>

      {/* Commission Table */}
      <div className="card border-0 shadow-sm">
        <div className="card-body p-4">
          <TableComponent
            title=""
            table_fields={tableFields}
            table_data={commissionData}
            row_data={rowData}
            pageSize={10}
            table_class="table-hover"
          />
        </div>
      </div>

      {/* Commission Download Modal */}
      <CommissionDownloadModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </div>
  );
}

export default CommissionsAccount;